exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:tags_filter;src:url(" + require("../fonts/tags-filter.eot?3lzqzp") + ");src:url(" + require("../fonts/tags-filter.eot") + "?#iefix3lzqzp) format(\"embedded-opentype\"),url(" + require("../fonts/tags-filter.woff?3lzqzp") + ") format(\"woff\"),url(" + require("../fonts/tags-filter.ttf?3lzqzp") + ") format(\"truetype\"),url(" + require("../fonts/tags-filter.svg?3lzqzp") + "#tags-filter) format(\"svg\");font-weight:400;font-style:normal}[class*=root-ico],[class^=root-ico]{font-family:tags_filter;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.root-ico_tags_arr:before{content:\"\\E621\"}.root-ico_tags:before{content:\"\\E629\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/css-loader?minimize!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/css/tags-filter.css
// module id = 418
// module chunks = 4